// export const API_URL = "https://615e-60-254-78-144.ngrok-free.app";
// export const API_URL = "https://0b9b-116-75-240-169.ngrok-free.app/";
// export const API_URL = "http://65.2.189.208:3001/api/v1/";
// export const API_URL = "http://13.200.55.131:3001/api/v1/";

// export const API_URL = "http://13.200.55.131:3001/api/v1/";
// export const API_URL_STAGING = "https://back.rainmaker.co.in/api/v1/";
// export const API_URL_SOCKET = "https://back.rainmaker.co.in/api/v1";

// export const API_URL_Two = "http://13.200.55.131:8081/api/v1/";
// export const SECRENT_KEY = ""
// export const API_URL = "https://lms.vector3.digital/api/v1/";
// export const API_URL_Two = "https://lms.vector3.digital/api/v1/";

let API_URL;
let API_URL_STAGING;
let API_URL_SOCKET;
let API_LEARNER;

if (process.env.REACT_APP_ENVIRONMENT === "staging") {
  API_URL = "http://13.200.55.131:3001/api/v1/";
  API_URL_STAGING = "https://back.rainmaker.co.in/api/v1/";
  API_URL_SOCKET = "https://back.rainmaker.co.in/api/v1";
  API_LEARNER = "https://learner.rainmaker.co.in/learner";
} else {
  API_URL = "http://13.200.55.131:3001/api/v1/";
  API_URL_STAGING = "https://rmadmin.rainmaker.co.in/api/v1/";
  API_URL_SOCKET = "https://rmadmin.rainmaker.co.in/api/v1";
  API_LEARNER = "https://rmexp.rainmaker.co.in/learner";
}

export { API_URL, API_URL_STAGING, API_URL_SOCKET, API_LEARNER };
